import React, { useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import configureStore from './redux/store';
import AppWrapper from './@jumbo/components/AppWrapper';
import AppContextProvider from './@jumbo/components/contextProvider/AppContextProvider';
import Layout from '../base/components/layout';
import { LanguageContextProvider } from '../base/context/language';
import { TitleContextProvider } from '../base/context/title';
import { ReloadContextProvider } from '../base/context/reload/reload.context';

export const store = configureStore();

export const NavigationContext = React.createContext();

const App = (props) => {
  const [{ pageTitleInfo, breadcrumbs }, setNavigationData] = useState({});

  return (
    <AppContextProvider>
      <TitleContextProvider>
        <ReloadContextProvider>
          <LanguageContextProvider>
            {() => {
              return (
                <AppWrapper>
                  <NavigationContext.Provider
                    value={{
                      setNavigationData,
                      breadcrumbs,
                      pageTitleInfo,
                    }}
                  >
                    <Layout {...props} />
                  </NavigationContext.Provider>
                </AppWrapper>
              );
            }}
          </LanguageContextProvider>
        </ReloadContextProvider>
      </TitleContextProvider>
    </AppContextProvider>
  );
};

export default App;
